import { observer } from "mobx-react-lite";

import { useRootStore } from "../../../../stores/hooks";
import { useEffect, useState } from "react";
import { LimitsDisclamer90 } from "./LimitsDisclamer90";
import { LimitsDisclamer100 } from "./LimitsDisclamer100";

export const LimitsDisclamer = observer(() => {
  const { limits } = useRootStore();

  const [show, setShow] = useState(false);
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (limits.limits.enforceLimit) {
      const percentage =
        limits.limits.limit > 0
          ? Math.floor((limits.limits.usage * 100) / limits.limits.limit)
          : 0;
      setPercentage(percentage);
      setShow(percentage >= 90);
    }
  }, [limits.limits.enforceLimit, limits.limits.usage, limits.limits.limit]);

  return show ? (
    percentage >= 100 ? (
      <LimitsDisclamer100 />
    ) : percentage >= 90 ? (
      <LimitsDisclamer90 />
    ) : null
  ) : null;
});
